module.exports = __webpack_public_path__ + "img/588.75017f39.jpg";